import _getIterator from 'babel-runtime/core-js/get-iterator';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';

export var getFirstKey = function getFirstKey(obj) {
  var keys = _Object$keys(obj);
  return keys && keys.length ? keys[0] : null;
};

export var isObjectEqual = function isObjectEqual(objectA, objectB, pickFields) {
  if (!pickFields) {
    return isEqual(objectA, objectB);
  }

  return isEqual(pick(objectA, pickFields), pick(objectB, pickFields));
};

export var areObjectsMatchingAtLeastOneField = function areObjectsMatchingAtLeastOneField(objectA, objectB, pickFields) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _getIterator(pickFields), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var field = _step.value;

      if (objectA[field] && objectA[field] === objectB[field]) {
        return true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return false;
};

export var hasAtleastOneKeyInArray = function hasAtleastOneKeyInArray(object, keys) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = _getIterator(keys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var k = _step2.value;

      if (typeof object[k] !== 'undefined') {
        return true;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return false;
};
//# sourceMappingURL=object.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/object.js
// module id = 383
// module chunks = 0